export const AddressType = Object.freeze({
    PER: "PER", // permanent address
    CON: "CON", // contact address
});
